module.exports = __webpack_public_path__ + "static/img/__9409.0a01080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9409.jpg
// module id = 8BIG
// module chunks = 0